// import React, { useState } from 'react';
// import {
//   FaMapMarkerAlt, // For Current Location
//   FaConciergeBell, // For Services (or another suitable icon)
//   FaRunning,        // For Activities
//   FaBook,           // For Bookings
//   FaChevronDown,    // For dropdown arrows
//   FaUser,           // For User/Profile icon
//   FaRegLightbulb // Or FaUpload, FaShoppingCart for the other icon
// } from 'react-icons/fa';

// const Navbar = () => {
//   const [activitiesOpen, setActivitiesOpen] = useState(false);
//   const [bookingsOpen, setBookingsOpen] = useState(false);

//   return (
//     <nav className="bg-white shadow-md p-4">
//       <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//         {/* Logo Section */}
//         <div className="flex-shrink-0">
//           {/* Replace with your actual logo image path */}
//           <img src="/upswap.png" alt="Upswap Logo" className="h-10" />
//           {/* Or if it's text: */}
//           {/* <span className="text-2xl font-bold text-orange-600">Upswap</span> */}
//         </div>

//         {/* Navigation Links Section (hidden on small screens, flex on medium and up) */}
//         <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
//           {/* Current Location */}
//           <a href="#" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 text-sm lg:text-base">
//             <FaMapMarkerAlt className="mr-2 text-red-400" /> Current Location
//           </a>

//           {/* Services */}
//           <a href="#" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 text-sm lg:text-base">
//             <FaConciergeBell className="mr-2 text-red-400" /> Services
//           </a>

//           {/* Activities Dropdown */}
//           <div className="relative">
//             <button
//               className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none text-sm lg:text-base"
//               onClick={() => setActivitiesOpen(!activitiesOpen)}
//             >
//               <FaRunning className="mr-2 text-red-400" /> Activities <FaChevronDown className={`ml-1 text-xs transition-transform duration-200 ${activitiesOpen ? 'rotate-180' : ''}`} />
//             </button>
//             {activitiesOpen && (
//               <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20 border border-gray-100">
//                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">All Activities</a>
//                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Live Activities</a>
//                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Scheduled Activities</a>
//                 {/* Add more activity links as needed */}
//               </div>
//             )}
//           </div>

//           {/* Bookings Dropdown */}
//           <div className="relative">
//             <button
//               className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none text-sm lg:text-base"
//               onClick={() => setBookingsOpen(!bookingsOpen)}
//             >
//               <FaBook className="mr-2 text-red-400" /> Bookings <FaChevronDown className={`ml-1 text-xs transition-transform duration-200 ${bookingsOpen ? 'rotate-180' : ''}`} />
//             </button>
//             {bookingsOpen && (
//               <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20 border border-gray-100">
//                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">My Bookings</a>
//                 <a href="#" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Past Bookings</a>
//                 {/* Add more booking links as needed */}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Right Section (Icons) */}
//         <div className="flex items-center space-x-4">
//           {/* Cart/Upload Icon (using FaRegLightbulb as a placeholder, change as needed) */}
//           <button className="text-gray-600 hover:text-orange-500 transition-colors duration-200 text-xl focus:outline-none">
//             <FaRegLightbulb /> {/* Or FaUpload, FaShoppingCart */}
//           </button>

//           {/* User/Profile Icon */}
//           <button className="text-gray-600 hover:text-orange-500 transition-colors duration-200 text-xl focus:outline-none">
//             <FaUser />
//           </button>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar;
// src/components/UserHeader.jsx (renamed from Navbar)

// import React, { useState } from 'react';
// import {
//     FaMapMarkerAlt, FaConciergeBell, FaRunning,
//     FaBook, FaChevronDown, FaUser, FaPlusSquare
// } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../Authentication/AuthContext';

// const UserHeader = () => {
//     const [activitiesOpen, setActivitiesOpen] = useState(false);
//     const [bookingsOpen, setBookingsOpen] = useState(false);
//     const [userDropdownOpen, setUserDropdownOpen] = useState(false);

//     const navigate = useNavigate();
//     const { logout, canPostActivities, kycStatus } = useAuth(); // kycStatus to check for KYC link

//     const handleLogout = () => {
//         logout();
//         navigate('/');
//     };

//     const handlePostActivityClick = () => {
//         if (canPostActivities) {
//             navigate('/post-activity');
//         } else {
//             // This case should ideally not be reachable if the button is correctly hidden/disabled.
//             // But good for defensive programming.
//             alert("Aap activity post nahi kar sakte hain.");
//         }
//     };

//     const handleCompleteKycClick = () => {
//         navigate('/kyc-submission');
//     };

//     return (
//         <nav className="bg-white shadow-md p-4">
//             <div className="max-w-screen-xl mx-auto flex justify-between items-center">
//                 {/* Logo Section */}
//                 <div className="flex-shrink-0">
//                     <img src="/upswap.png" alt="Upswap Logo" className="h-10" />
//                 </div>

//                 {/* Navigation Links Section */}
//                 <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
//                     <a href="/location" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 text-sm lg:text-base">
//                         <FaMapMarkerAlt className="mr-2 text-red-400" /> Current Location
//                     </a>

//                     <a href="/services" className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 text-sm lg:text-base">
//                         <FaConciergeBell className="mr-2 text-red-400" /> Services
//                     </a>

//                     <div className="relative">
//                         <button
//                             className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none text-sm lg:text-base"
//                             onClick={() => setActivitiesOpen(!activitiesOpen)}
//                         >
//                             <FaRunning className="mr-2 text-red-400" /> Activities <FaChevronDown className={`ml-1 text-xs transition-transform duration-200 ${activitiesOpen ? 'rotate-180' : ''}`} />
//                         </button>
//                         {activitiesOpen && (
//                             <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20 border border-gray-100">
//                                 <a href="/activities/all" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">All Activities</a>
//                                 <a href="/activities/live" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Live Activities</a>
//                                 <a href="/activities/scheduled" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Scheduled Activities</a>
//                             </div>
//                         )}
//                     </div>

//                     <div className="relative">
//                         <button
//                             className="flex items-center text-gray-700 hover:text-orange-500 transition-colors duration-200 focus:outline-none text-sm lg:text-base"
//                             onClick={() => setBookingsOpen(!bookingsOpen)}
//                         >
//                             <FaBook className="mr-2 text-red-400" /> Bookings <FaChevronDown className={`ml-1 text-xs transition-transform duration-200 ${bookingsOpen ? 'rotate-180' : ''}`} />
//                         </button>
//                         {bookingsOpen && (
//                             <div className="absolute left-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20 border border-gray-100">
//                                 <a href="/my-bookings" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">My Bookings</a>
//                                 <a href="/past-bookings" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">Past Bookings</a>
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 {/* Right Section (Icons) */}
//                 <div className="flex items-center space-x-4">
//                     {/* Post Activity Button */}
//                     {canPostActivities && (
//                         <button
//                             className="text-gray-600 hover:text-orange-500 transition-colors duration-200 text-xl focus:outline-none"
//                             onClick={handlePostActivityClick}
//                             title="Post an Activity"
//                         >
//                             <FaPlusSquare />
//                         </button>
//                     )}

//                     {/* User Profile Dropdown */}
//                     <div className="relative">
//                         <button
//                             className="text-gray-600 hover:text-orange-500 transition-colors duration-200 text-xl focus:outline-none"
//                             onClick={() => setUserDropdownOpen(!userDropdownOpen)}
//                         >
//                             <FaUser />
//                         </button>
//                         {userDropdownOpen && (
//                             <div className="absolute right-0 mt-2 w-40 bg-white rounded-md shadow-lg py-1 z-20 border border-gray-100">
//                                 <a href="/profile" className="block px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm">My Profile</a>
//                                 {/* Show KYC link if not yet a vendor or KYC is not approved */}
//                                 {kycStatus !== 'approved' && (
//                                     <button
//                                         onClick={handleCompleteKycClick}
//                                         className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm"
//                                     >
//                                         Complete KYC
//                                     </button>
//                                 )}
//                                 <button
//                                     onClick={handleLogout}
//                                     className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 text-sm"
//                                 >
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default UserHeader;

import { useState, useEffect } from "react";
import { useRef } from "react";

import {
  FaChevronDown,
  FaBars,
  FaUser,
  FaStore,
  FaBriefcase,
  FaQuestionCircle,
  FaGift,
  FaSun,
  FaBell,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Switch } from "@headlessui/react";
import axios from "axios";
import { toast } from "react-toastify";
// import LogOut from "../Authentication/LogOut"; // Adjust path if LogOut is in a different directory

// Accept props for sidebar state management
function Header({ isSideMenuOpen, setIsSideMenuOpen }) {
  // <--- Added these props
  const [isDealsHovered, setIsDealsHovered] = useState(false);
  const [isActivityHovered, setIsActivityHovered] = useState(false);
  // isSideMenuOpen state is now managed by the parent Layout component
  const [isApproved, setIsApproved] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState(true);
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
const profileDropdownRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      profileDropdownRef.current &&
      !profileDropdownRef.current.contains(event.target)
    ) {
      setIsProfileDropdownOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const fetchKYCStatus = async () => {
    const vendorId = localStorage.getItem("vendor_id");
    if (!vendorId) {
      console.warn(
        "No vendor ID found in localStorage. Cannot fetch KYC status."
      );
      setIsApproved(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://api.upswap.app/api/vendor/status/${vendorId}/`
      );
      const updatedStatus = response.data.is_approved;
      setIsApproved(updatedStatus);
    } catch (error) {
      console.error("Failed to fetch KYC status", error);
      setIsApproved(false);
      toast.error("Failed to load KYC status.");
    }
  };

  useEffect(() => {
    fetchKYCStatus();
    const interval = setInterval(fetchKYCStatus, 1000000);
    return () => clearInterval(interval);
  }, []);

  let dealsTimeout;
  let activityTimeout;

  const handleDealsMouseEnter = () => {
    clearTimeout(dealsTimeout); // Clear any pending close timeout
    setIsDealsHovered(true);
  };

  const handleDealsMouseLeave = () => {
    dealsTimeout = setTimeout(() => {
      setIsDealsHovered(false);
    }, 200); // Close after 200ms if mouse leaves
  };

  const handleActivityMouseEnter = () => {
    clearTimeout(activityTimeout); // Clear any pending close timeout
    setIsActivityHovered(true);
  };

  const handleActivityMouseLeave = () => {
    activityTimeout = setTimeout(() => {
      setIsActivityHovered(false);
    }, 200); // Close after 200ms if mouse leaves
  };

  const handleDealClick = (type) => {
    if (type === "Live Deals") navigate("/MyDeals/live");
    else if (type === "Scheduled Deals") navigate("/MyDeals/scheduled");
    else if (type === "History Deals") navigate("/MyDeals/history");
    else if (type === "All Deals") navigate("/MyDeals/all");
    setIsDealsHovered(false); // Close dropdown after click
  };

  const handleActivityClick = (type) => {
    if (type === "All Activities") {
      navigate("/MyActivities/All", { state: { filter: "all" } });
    } else if (type === "Live Activities") {
      navigate("/MyActivities/Live", { state: { filter: "live" } });
    } else if (type === "Scheduled Activities") {
      navigate("/MyActivities/Scheduled", { state: { filter: "scheduled" } });
    } else if (type === "Participation Activities") {
      navigate("/MyActivities/Participation", {
        state: { filter: "participation" },
      });
    } else if (type === "History Activities") {
      navigate("/MyActivities/History", { state: { filter: "history" } });
    }

    setIsActivityHovered(false); // close the dropdown after click
  };

  const handleSideMenuItemClick = async (route, title) => {
    setIsSideMenuOpen(false); // Close side menu on item click
    const vendorId = localStorage.getItem("vendor_id");

    if (title === "My Business Account") {
      if (!vendorId) {
        console.error("No vendor ID found.");
        toast.error("Please log in to view business account details.");
        return;
      }
      try {
        const response = await axios.get(
          `https://api.upswap.app/api/vendor/details/${vendorId}/`
        );
        const vendorDetails = response.data;
        localStorage.setItem("vendor_details", JSON.stringify(vendorDetails));
        navigate(route);
      } catch (error) {
        console.error("Error fetching vendor details:", error);
        toast.error("Failed to load business account details.");
      }
    } else {
      navigate(route);
    }
  };

  const sideMenuItems = [
    {
      icon: <FaUser />,
      title: "My Personal Account",
      subtitle: "Account Settings and orders",
      route: "/MyPersonalAccount",
    },
    {
      icon: <FaStore />,
      title: "Explore Nearby Vendors",
      subtitle: "Explore and save local favourite vendors",
      route: "/PopularDeals",
    },
    {
      icon: <FaBriefcase />,
      title: "My Business Account",
      subtitle: "Complete your profile for posting deals",
      route: "/BasicInfo",
      showKycStatus: true,
    },
    {
      icon: <FaQuestionCircle />,
      title: "Help Center",
      subtitle: "Contact Us, Report, tutorials & more",
      route: "/MyActivities/All", // Changed to a specific route that exists
    },
    {
      icon: <FaGift />,
      title: "Refer a Friend",
      subtitle: "Earn rewards for inviting friends",
      route: "/UpswapVendors",
    },
  ];

  return (
    <>
      <header className="bg-white z-50 relative text-gray-700 font-medium flex items-center justify-between gap-8 px-4 sm:px-6 md:px-8 py-3 max-w-screen-2xl mx-auto">
        {" "}
        {/* Left Section: Upswap Icon */}
        <div className="flex items-center">
          <img
            src="/upswap.png"
            alt="logo"
            className="w-auto h-12 rounded-md cursor-pointer"
            onClick={() => navigate("/Home")}
          />
        </div>
        {/* Center Navigation Links */}
        <nav className="hidden md:flex items-center gap-12 flex-grow justify-center opacity-80">
          <button
            className="text-black hover:text-orange-500 transition "
            onClick={() => navigate("/Home")}
          >
            Home
          </button>

          {/* My Deals Dropdown */}
          <div
            className="relative"
            onMouseEnter={handleDealsMouseEnter}
            onMouseLeave={handleDealsMouseLeave}
          >
            <button className="text-black flex items-center gap-1 hover:text-orange-500 transition">
              My Deals
              <FaChevronDown className="text-xs mt-1" />
            </button>
            {isDealsHovered && (
              // <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white text-gray-800 rounded-md shadow-lg py-1 z-20">
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white text-gray-800 rounded-md shadow-lg py-1 z-50">
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleDealClick("Live Deals")}
                >
                  Live Deals
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleDealClick("Scheduled Deals")}
                >
                  Scheduled Deals
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleDealClick("History Deals")}
                >
                  History Deals
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleDealClick("All Deals")}
                >
                  All Deals
                </button>
              </div>
            )}
          </div>

          <button
            className="text-black hover:text-orange-500 transition"
            onClick={() => navigate("/UpswapFeatures")}
          >
            UpSwap
          </button>

          {/* My Activity Dropdown */}
          <div
            className="relative"
            onMouseEnter={handleActivityMouseEnter}
            onMouseLeave={handleActivityMouseLeave}
          >
            <button className="text-black flex items-center gap-1 hover:text-orange-500 transition">
              My Activity
              <FaChevronDown className="text-xs mt-1" />
            </button>
            {isActivityHovered && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-48 bg-white text-gray-800 rounded-md shadow-lg py-1 z-50">
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleActivityClick("All Activities")}
                >
                  All Activities
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleActivityClick("Live Activities")}
                >
                  Live Activities
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleActivityClick("Scheduled Activities")}
                >
                  Scheduled Activities
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() =>
                    handleActivityClick("Participation Activities")
                  }
                >
                  Participation Activities
                </button>
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-orange-100 rounded-lg"
                  onClick={() => handleActivityClick("History Activities")}
                >
                  History Activities
                </button>
              </div>
            )}
          </div>

          <button
            className="text-black hover:text-orange-500 transition"
            onClick={() => navigate("/UpswapVendors")}
          >
            Vendors
          </button>
        </nav>
        {/* Right Section: Login/Sign Up Buttons and Side Menu Icon */}
        <div className="flex items-center gap-4 mr-10 relative">
  {/* Side Menu Icon */}
  <button
    className="text-2xl text-gray-700"
    onClick={() => setIsSideMenuOpen(true)}
  >
    <FaBars />
  </button>

  {/* User Profile Icon */}
<div className="relative" ref={profileDropdownRef}>
  <button
    className="text-2xl text-gray-700"
    onClick={() => setIsProfileDropdownOpen((prev) => !prev)}
  >
    <FaUser />
  </button>

  {isProfileDropdownOpen && (
    <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
      <button
        onClick={() => {
          navigate("/MyPersonalAccount");
          setIsProfileDropdownOpen(false);
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100"
      >
        My Profile
      </button>
      <button
        onClick={() => {
          localStorage.clear();
          navigate("/Login");
        }}
        className="w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
      >
        Logout
      </button>
    </div>
  )}
</div>

</div>

      </header>

      {/* Side Menu Drawer */}
      {isSideMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-50 rounded-t-xl"
          onClick={() => setIsSideMenuOpen(false)} // Uses the setter from props
        >
          {/* rounded-s-sm */}
          <div
            className="fixed top-0 right-0 w-[260px] h-full bg-slate-100  shadow-lg p-4 overflow-y-auto" // Set explicit width
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bg-white p-1 rounded-md shadow-md mb-4">
              <h2 className="font-semibold flex justify-center items-center px-6 py-6 rounded-lg">
                <img
                  src="/upswap.png"
                  alt="logo"
                  className="w-32 h-12 object-cover rounded-lg"
                />
              </h2>
            </div>

            {/* <button
              className="text-md mb-4 text-gray-700 hover:text-red-500"
              onClick={() => setIsSideMenuOpen(false)}
            >
              {/* × */}
            {/* ✖  */}
            {/* </button> */}
            <div className="flex justify-end">
              {" "}
              {/* Added flex and justify-end */}
              <button
                className="hover:text-red-500" // Changed text-md to text-xl for a slightly larger 'X'
                onClick={() => setIsSideMenuOpen(false)}
              >
                ❌
              </button>
            </div>

            {isApproved === false && (
              <div className="bg-yellow-100 text-yellow-800 p-2 text-center rounded-md mt-4 mx-2">
                Your KYC Approval is revoked. Please wait for approval.
              </div>
            )}

            <h3 className="text-[#FE7A3A] font-semibold mt-6 ml-2">
              Main Menu
            </h3>
            <ul className="space-y-2 mt-4">
              {sideMenuItems.map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      handleSideMenuItemClick(item.route, item.title)
                    }
                    className="flex items-center w-full p-2 rounded-lg cursor-pointer hover:bg-slate-200"
                  >
                    <span className="text-[#FE7A3A] text-xl mr-3">
                      {item.icon}
                    </span>
                    <div className="flex flex-col items-start">
                      <h3 className="font-semibold text-black flex items-center gap-2">
                        {item.title}
                      </h3>
                      {item.showKycStatus && isApproved !== null && (
                        <span
                          className={`text-xs font-semibold mt-1 ${
                            isApproved ? "text-green-600" : "text-red-400"
                          }`}
                        >
                          {/* ❌ */}
                          {isApproved ? "✅ Approved" : "⏳ In Review"}
                        </span>
                      )}
                    </div>
                  </button>
                </li>
              ))}
            </ul>

            <h3 className="text-[#FE7A3A] font-semibold mt-6 ml-2">Settings</h3>

            <div className="flex items-center justify-between mt-3 ml-2">
              <div className="flex items-center space-x-2">
                <FaSun className="text-[#FE7A3A]" />
                <span>Dark Mode</span>
              </div>
              <Switch
                checked={darkMode}
                onChange={setDarkMode}
                className={`${
                  darkMode ? "bg-green-500" : "bg-gray-300"
                } relative inline-flex h-6 w-11 items-center rounded-full`}
              >
                <span className="sr-only">Enable Dark Mode</span>
                <span
                  className={`${
                    darkMode ? "translate-x-6" : "translate-x-1"
                  } inline-block h-4 w-4 transform bg-white rounded-full`}
                />
              </Switch>
            </div>

            <div className="flex items-center justify-between mt-3 ml-2">
              <div className="flex items-center space-x-2">
                <FaBell className="text-[#FE7A3A]" />
                <span>Notifications</span>
              </div>
              <Switch
                checked={notifications}
                onChange={setNotifications}
                className={`${
                  notifications ? "bg-green-500" : "bg-gray-300"
                } relative inline-flex h-6 w-11 items-center rounded-full`}
              >
                <span className="sr-only">Enable Notifications</span>
                <span
                  className={`${
                    notifications ? "translate-x-6" : "translate-x-1"
                  } inline-block h-4 w-4 transform bg-white rounded-full`}
                />
              </Switch>
            </div>
            {/* <LogOut /> */}
          </div>
        </div>
      )}
    </>
  );
}

export default Header;

//  for vendor header

// import { useState } from "react";
// import { FaTh, FaCalendarAlt, FaChartBar, FaUsers, FaBell, FaUser, FaChevronDown } from "react-icons/fa";

// export default function Header() {
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const toggleDropdown = (name) => {
//     setOpenDropdown(openDropdown === name ? null : name);
//   };

//   return (
//     <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//       {/* Logo */}
//       <div className="flex items-center">
//         <img src="/upswap.png" alt="UpSwap" className="h-12 w-auto" />
//       </div>

//       {/* Center Nav */}
//       <nav className="hidden md:flex items-center space-x-6">
//         <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//           <FaTh /> Dashboard
//         </button>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("appointments")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaCalendarAlt /> Appointments <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "appointments" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Upcoming</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Past</button>
//             </div>
//           )}
//         </div>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("services")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaChartBar /> Services & Deals <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "services" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">All Services</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Active Deals</button>
//             </div>
//           )}
//         </div>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("staff")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaUsers /> Staff <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "staff" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Team</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Roles</button>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Right Side */}
//       <div className="flex items-center space-x-4">
//         <button className="relative">
//           <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//           <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//         </button>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("profile")}
//             className="flex items-center text-gray-700 hover:text-orange-500"
//           >
//             <FaUser className="text-xl" /> <FaChevronDown className="ml-1 text-xs" />
//           </button>
//           {openDropdown === "profile" && (
//             <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Profile</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Logout</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// for user header

// import { useState } from "react";
// import { FaMapMarkerAlt, FaUsers, FaGift, FaCalendarAlt, FaBell, FaUser, FaChevronDown } from "react-icons/fa";

// export default function Header() {
//   const [isActivitiesOpen, setIsActivitiesOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [isBookingsOpen, setIsBookingsOpen] = useState(false);
//   const [isProfileOpen, setIsProfileOpen] = useState(false);

//   return (
//     <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//       {/* Logo */}
//       <div className="flex items-center">
//         <img  src="/upswap.png" alt="UpSwap" className="h-10 w-auto" />
//       </div>

//       {/* Center Nav */}
//       <nav className="hidden md:flex items-center space-x-6">
//         <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//           <FaMapMarkerAlt /> Current Location
//         </button>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsActivitiesOpen(true)}
//           onMouseLeave={() => setIsActivitiesOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaUsers /> Activities <FaChevronDown className="text-xs" />
//           </button>
//           {isActivitiesOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">All Activities</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Live Activities</button>
//             </div>
//           )}
//         </div>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsServicesOpen(true)}
//           onMouseLeave={() => setIsServicesOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaGift /> Services <FaChevronDown className="text-xs" />
//           </button>
//           {isServicesOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Service 1</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Service 2</button>
//             </div>
//           )}
//         </div>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsBookingsOpen(true)}
//           onMouseLeave={() => setIsBookingsOpen(false)}
//         >
//           <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//             <FaCalendarAlt /> Bookings <FaChevronDown className="text-xs" />
//           </button>
//           {isBookingsOpen && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">My Bookings</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">History</button>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Right Side: Notifications + Profile */}
//       <div className="flex items-center space-x-4">
//         <button className="relative">
//           <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//           <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//         </button>

//         <div
//           className="relative"
//           onMouseEnter={() => setIsProfileOpen(true)}
//           onMouseLeave={() => setIsProfileOpen(false)}
//         >
//           <button className="flex items-center text-gray-700 hover:text-orange-500">
//             <FaUser className="text-xl" /> <FaChevronDown className="ml-1 text-xs" />
//           </button>
//           {isProfileOpen && (
//             <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Profile</button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">Logout</button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// import { useState, useEffect } from "react";
// import { FaChevronDown, FaBars, FaUser, FaStore, FaBriefcase, FaQuestionCircle, FaGift, FaSun, FaBell } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { Switch } from "@headlessui/react";
// import axios from "axios";
// // import LogOut from "./LogOut"; // Make sure to adjust the import path

// export default function Header() {
//   const [isDealsHovered, setIsDealsHovered] = useState(false);
//   const [isActivityHovered, setIsActivityHovered] = useState(false);
//   const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
//   const [isApproved, setIsApproved] = useState(null);
//   const navigate = useNavigate();

//   let dealsTimeout;
//   let activityTimeout;

//   const handleDealsMouseEnter = () => {
//     clearTimeout(dealsTimeout);
//     setIsDealsHovered(true);
//   };

//   const handleDealsMouseLeave = () => {
//     dealsTimeout = setTimeout(() => {
//       setIsDealsHovered(false);
//     }, 200);
//   };

//   const handleActivityMouseEnter = () => {
//     clearTimeout(activityTimeout);
//     setIsActivityHovered(true);
//   };

//   const handleActivityMouseLeave = () => {
//     activityTimeout = setTimeout(() => {
//       setIsActivityHovered(false);
//     }, 200);
//   };

//   const handleActivityClick = (type) => {
//     if (type === "All Activities") navigate("/MyActivities/All");
//     else if (type === "Live Activities") navigate("/MyActivities/Live");
//     else if (type === "Scheduled Activities") navigate("/MyActivities/Scheduled");
//     else if (type === "History") navigate("/MyActivities/History");
//   };

//   const fetchKYCStatus = async () => {
//     const vendorId = localStorage.getItem("vendor_id");
//     if (!vendorId) return;

//     try {
//       const response = await axios.get(
//         `https://api.upswap.app/api/vendor/status/${vendorId}/`
//       );
//       setIsApproved(response.data.is_approved);
//     } catch (error) {
//       console.error("Failed to fetch KYC status", error);
//     }
//   };

//   useEffect(() => {
//     fetchKYCStatus();
//     const interval = setInterval(fetchKYCStatus, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const menuItems = [
//     {
//       icon: <FaUser />,
//       title: "My Personal Account",
//       route: "/MyPersonalAccount",
//     },
//     {
//       icon: <FaStore />,
//       title: "Explore Nearby Vendors",
//       route: "/DealsPage",
//     },
//     {
//       icon: <FaBriefcase />,
//       title: "My Business Account",
//       route: "/BasicInfo",
//     },
//     {
//       icon: <FaQuestionCircle />,
//       title: "Help Center",
//       route: "/MyActivities",
//     },
//     {
//       icon: <FaGift />,
//       title: "Refer a Friend",
//       route: "/UpswapVendors",
//     },
//   ];

//   return (
//     <div>
//       {/* Header Top Bar */}
//       <div className="flex justify-between items-center p-4 bg-white shadow">
//         <h1 className="text-xl font-bold">Your App Header</h1>
//         <FaBars
//           className="text-2xl cursor-pointer"
//           onClick={() => setIsSideMenuOpen(!isSideMenuOpen)}
//         />
//       </div>

//       {/* SideMenu Component */}
//       {isSideMenuOpen && (
//         <SideMenu
//           isApproved={isApproved}
//           menuItems={menuItems}
//           navigate={navigate}
//           closeMenu={() => setIsSideMenuOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

// const SideMenu = ({ isApproved, menuItems, navigate, closeMenu }) => {
//   const [darkMode, setDarkMode] = useState(false);
//   const [notifications, setNotifications] = useState(true);

//   return (
//     <div className="fixed left-0 top-0 w-[260px] h-screen bg-slate-100 shadow-lg z-50 overflow-y-auto">
//       <div className="bg-white p-1 rounded-md shadow-md flex justify-between items-center">
//         <h2 className="font-semibold flex justify-center items-center px-6 py-6">
//           <img
//             src="/upswap.png"
//             alt="logo"
//             className="w-32 h-12 object-cover rounded-lg"
//           />
//         </h2>
//         <button
//           onClick={closeMenu}
//           className="text-xl px-4 py-2 hover:text-red-500"
//         >
//           ✖
//         </button>
//       </div>

//       {/* KYC Status Notice */}
//       {isApproved === false && (
//         <div className="bg-yellow-100 text-yellow-800 p-2 text-center rounded-md mt-4 mx-4">
//           Your KYC Approval is revoked. Please wait for approval.
//         </div>
//       )}

//       <div className="text-left ml-4 mt-4 text-[#FE7A3A] font-semibold">
//         Main Menu
//       </div>

//       <div className="mt-4 space-y-2">
//         {menuItems.map((item, index) => (
//           <div
//             key={index}
//             className="flex items-center justify-between bg-white w-[240px] mx-auto p-3 rounded-lg shadow-sm border cursor-pointer"
//             onClick={() => {
//               navigate(item.route);
//               closeMenu();
//             }}
//           >
//             <div className="flex items-center space-x-3">
//               <span className="text-[#FE7A3A] text-xl">{item.icon}</span>
//               <div>
//                 <h3 className="font-semibold text-black">
//                   {item.title}
//                 </h3>
//               </div>
//             </div>
//             {item.title === "My Business Account" && isApproved && (
//               <span className="text-green-600 text-sm font-semibold">
//                 ✅ Approved
//               </span>
//             )}
//           </div>
//         ))}
//       </div>

//       {/* Settings Section */}
//       <div className="mt-6 bg-white p-4 rounded-lg shadow-md w-[240px] mx-auto">
//         <h3 className="text-[#FE7A3A] font-semibold">Settings</h3>

//         <div className="flex items-center justify-between mt-3">
//           <div className="flex items-center space-x-2">
//             <FaSun className="text-[#FE7A3A]" />
//             <span>Dark Mode</span>
//           </div>
//           <Switch
//             checked={darkMode}
//             onChange={setDarkMode}
//             className={`${
//               darkMode ? "bg-green-500" : "bg-gray-300"
//             } relative inline-flex h-6 w-11 items-center rounded-full`}
//           >
//             <span className="sr-only">Enable Dark Mode</span>
//             <span
//               className={`${
//                 darkMode ? "translate-x-6" : "translate-x-1"
//               } inline-block h-4 w-4 transform bg-white rounded-full`}
//             />
//           </Switch>
//         </div>

//         <div className="flex items-center justify-between mt-3">
//           <div className="flex items-center space-x-2">
//             <FaBell className="text-[#FE7A3A]" />
//             <span>Notifications</span>
//           </div>
//           <Switch
//             checked={notifications}
//             onChange={setNotifications}
//             className={`${
//               notifications ? "bg-green-500" : "bg-gray-300"
//             } relative inline-flex h-6 w-11 items-center rounded-full`}
//           >
//             <span className="sr-only">Enable Notifications</span>
//             <span
//               className={`${
//                 notifications ? "translate-x-6" : "translate-x-1"
//               } inline-block h-4 w-4 transform bg-white rounded-full`}
//             />
//           </Switch>
//         </div>
//       </div>

//       {/* <LogOut /> */}
//     </div>
//   );
// };
